import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const ArticleEditPage = lazy(() => import("./ArticleEditPage"));
const ArticleNewPage = lazy(() => import("./ArticleNewPage"));

const articleRoutes: RouteObject[] = [
  {
    path: "/blogs/:blog_slug/articles/new",
    element: (
      <Suspense fallback={<Loading />}>
        <ArticleNewPage />
      </Suspense>
    ),
  },
  {
    path: "/blogs/:blog_slug/articles/:slug/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <ArticleEditPage />
      </Suspense>
    ),
  },
];

export default articleRoutes;
